import React, { lazy } from 'react';

import { AgentVersionPickerBoundary } from './AgentVersionPickerBoundary';

const LegacyAgentVersionPickerLazy = lazy(() =>
	import(
		/* webpackChunkName: "@atlassian/conversation-assistant/agent-version-picker" */ './LegacyAgentVersionPickerInternal'
	).then((m) => ({ default: m.LegacyAgentVersionPickerInternal })),
);

/**
 * @private
 * @deprecated Remove when the rovo_agent_conversation_starters_relay feature gate is cleaned up.
 */
export const LegacyAgentVersionPicker = (): React.JSX.Element => (
	<AgentVersionPickerBoundary>
		<LegacyAgentVersionPickerLazy />
	</AgentVersionPickerBoundary>
);
